export default {
  error: '',
  questionnaireLead: {
    Language: 'en-US'
  },
  leadWizard: {},
  leadWizardError:'',
  mode:1,
  stepDetails:[],
  stepDetailError:''
};
